import React from 'react';

const GetStarted = () => <div><h2>Get Started</h2></div>;

export default GetStarted;
